<template>
  <component :is="embocheData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No Succursale found -->
    <b-alert variant="danger" :show="embocheData === undefined">
      <h4 class="alert-heading">Erreur lors de chargement du contenu</h4>
      <div class="alert-body">
        Aucun element trouvé avec cet identifiant. Vérifier
        <b-link class="alert-link" :to="{ name: 'emboche-list' }">
          Liste des elements
        </b-link>
        pour les autres element.
      </div>
    </b-alert>

    <data-add-tab :emboche-data="embocheData" class="mt-2" />
  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import storeModule from "./storeModule";
import DataAddTab from "./FormData.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormCheckbox,
    DataAddTab,
    BButton,
    // DataAddTabInformation,
    // DataAddTabSocial,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
    };
  },
  mounted() {
    if (router.currentRoute.name == "emboche-add-new") {
      this.operationTitle = "Nouvelle Succursale";
      this.operationIcon = "AddIcon";
    }
    if (router.currentRoute.name == "emboche-view") {
      this.operationTitle = "Détails de la Succursale";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "emboche-edit") {
      this.operationTitle = "Modification du Succursale";
      this.operationIcon = "EditIcon";
    }
  },
  methods: {
    prevPage() {
      router.push({ name: "emboche-list" });
    },
    convertBoolToInt(value) {
      if (value == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  setup() {
    let embocheData = ref(null);
    let APP_STORE_MODULE_NAME = "app-emboche";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    var defaultembocheData = ref({
      name: "",
      director: "",
      country: "",
      state: "",
      town: "",
    });

    if (router.currentRoute.name == "emboche-add-new") {
      // init empty emboche data
      embocheData = defaultembocheData;
    } else {
      // requirement //
      store
        .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          embocheData.value = response.data;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            embocheData.value = undefined;
          }
        });
    }

    return {
      embocheData,
    };
  },
};
</script>
